import React from "react";
import Box from "@mui/material/Box";
import CoreButtonIcon from "../../../core/components/CoreButtonIcon/CoreButtonIcon";
import Modal from "@mui/material/Modal";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const CoreModal = ({ component, disableScroll, disableClose, ...props }) => {
  const { onClose, state } = props;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // minWidth: 500,
    // minHeight: 500,
    bgcolor: "background.paper",
    // border: '2px solid #000',
    boxShadow: 24,
    px: 4,
    py: disableClose ? 1 : 4,
    borderRadius: 2,
  };
  return (
    <Modal
      className="rounded-md"
      open={state}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        width={props.width}
        height={props.height}
        className={disableScroll ? "" : "overflow-y-scroll"}
      >
        {!disableClose && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {onClose !== null && (
              <CoreButtonIcon
                onClick={onClose}
                icon={<CloseRoundedIcon color="error" />}
              />
            )}
          </div>
        )}

        {component}
      </Box>
    </Modal>
  );
};

export default CoreModal;
